import Breadcrumb from 'bee-breadcrumb'

export default Breadcrumb
